// tslint:disable:object-literal-sort-keys
const zIndex = {
  one: 1,
  ten: 10,
  hundred: 100,
  thounsand: 1000,
};

export default zIndex;
